import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { defaultDoc } from '../share/defaultDoc';

export interface Urgency {
  readonly name: string;
  readonly id: string;
  readonly discipline: number;
  readonly sort: number;
  readonly isActive: boolean;
  readonly dateModified: string;
}

export const urgencySchema: RxJsonSchema<Urgency> = {
  type: 'object',
  version: 0,
  description: 'describes Urgency',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export type UrgencyCollection = RxCollection<Urgency> | null;
export type UrgencyDocument = RxDocument<Urgency>;

export const urgencyPullQueryBuilder = (document: Urgency) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query urgencyFeed($lastRequested: DateTime) {
      urgencyFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};

export default {};
